module.exports = __webpack_public_path__ + "static/media/25114627_1545557768827192_917739795_n_edited.bbd66825.jpg";